module.exports = __webpack_public_path__ + "static/img/homeProduct1.9ac40b7a.png";